import type { Dispatch, Middleware } from "@reduxjs/toolkit";

import { createCommonTrackingMiddleware } from "../../../commons/store/middlewares/tracking";
import coreSlice from "../../../commons/store/slices/core";
import type initMobileMixpanel from "../../libs/externals/mixpanel";
import type { MobileAppActions, MobileAppState } from "../types";

export function createMobileTrackingMiddleware(
  mixpanel: ReturnType<typeof initMobileMixpanel>
): Middleware<EmptyObject, MobileAppState, Dispatch<MobileAppActions>> {
  const commonMiddleware = createCommonTrackingMiddleware(mixpanel);

  return _store => next => _action => {
    const action = _action as MobileAppActions;

    // Call common middleware first (handles modal, error, initAppDone tracking)
    commonMiddleware(_store)(next)(action);

    switch (action.type) {
      // Init - mobile-specific user profile (common middleware handles super properties)
      case coreSlice.actions.initAppDone.type:
        mixpanel.setUserProfile();
        break;

      default:
        break;
    }
  };
}
